/*global google*/
/*global window*/
import React from "react";
import { useHistory } from "react-router-dom";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  GroundOverlay,
  Marker,
} from "react-google-maps";
import NumberFormat from "react-number-format";
import { Button, Form, FormTextInput, Grid, Icon } from "tabler-react";
import * as qs from "qs";
import { ScrollElement, scroller } from "react-scroll";
import Modal from "react-modal";
import { PMT, PV } from "@formulajs/formulajs";
import InputMask from "react-input-mask";
import { UseDebounce } from "../components";
import moment from "moment";
import { isMobile } from "react-device-detect";
import CurrencyInput, { formatValue } from "react-currency-input-field";
import { cpf } from "cpf-cnpj-validator";

Modal.setAppElement("#root");

const Map = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap
      ref={props.mapRef}
      mapTypeId={google.maps.MapTypeId.SATELLITE}
      options={{
        fullscreenControl: false,
        mapTypeControl: false,
        scrollwheel: true,
        signInControl: false,
        streetViewControl: false,
      }}
      defaultZoom={props.mapZoom}
      defaultCenter={{
        lat: parseFloat(props.data?.project?.nativeMapLatitude || 0),
        lng: parseFloat(props.data?.project?.nativeMapLongitute || 0),
      }}
    >
      {props.data && (
        <GroundOverlay
          defaultUrl={props.data?.project.nativeMapOverlayImageUrl}
          defaultBounds={
            new google.maps.LatLngBounds(
              new google.maps.LatLng(
                parseFloat(
                  props.data?.project.nativeMapOverlayImageLeftLatitude,
                ),
                parseFloat(
                  props.data?.project.nativeMapOverlayImageLeftLongitude,
                ),
              ),
              new google.maps.LatLng(
                parseFloat(
                  props.data?.project.nativeMapOverlayImageRightLatitude,
                ),
                parseFloat(
                  props.data?.project.nativeMapOverlayImageRightLongitude,
                ),
              ),
            )
          }
        />
      )}
      {props.data &&
        props.data?.lots?.map((lot) => (
          <Marker
            key={lot.id}
            position={{
              lat: lot.data?.coordinate.latitude,
              lng: lot.data?.coordinate.longitude,
            }}
            motionTracking={false}
            icon={
              lot.id === props.selectedLot.id
                ? null
                : lot.status === "À VENDA" &&
                    lot.preReservationCode &&
                    lot.preReservationEnabled &&
                    lot.isOwner
                  ? "https://www.guerini.com.br/mapadevendas/images/ICON_BLUE.png"
                  : lot.status === "À VENDA" &&
                      lot.preReservationCode &&
                      lot.preReservationEnabled
                    ? "https://www.guerini.com.br/mapadevendas/images/RESERVADO.png"
                    : lot.status === "RESERVADO" &&
                        lot.isOwner &&
                        lot.preReservationStatus === "waiting_for_audit"
                      ? "https://www.guerini.com.br/mapadevendas/images/ICON_CHECKLIST.png"
                      : lot.status === "RESERVADO" &&
                          lot.isOwner &&
                          lot.preReservationStatus === "approved"
                        ? "https://www.guerini.com.br/mapadevendas/images/ICON_CONFIRM_W.png"
                        : lot.status === "RESERVADO" &&
                            lot.isOwner &&
                            lot.preReservationStatus === "reproved"
                          ? "https://www.guerini.com.br/mapadevendas/images/ICON_X.png"
                          : lot.status === "À VENDA"
                            ? "https://www.guerini.com.br/mapadevendas/images/AVENDA.png"
                            : lot.status === "VENDIDO"
                              ? "https://www.guerini.com.br/mapadevendas/images/VENDIDO.png"
                              : lot.status === "RESERVADO"
                                ? "https://www.guerini.com.br/mapadevendas/images/RESERVADO.png"
                                : "https://www.guerini.com.br/mapadevendas/images/SEMSTATUS.png"
            }
            onClick={() => props.onLotClick(lot)}
          />
        ))}
      {props.data &&
        props.data?.linkedLots?.map((lot) => (
          <Marker
            key={lot.id}
            position={{
              lat: lot.data?.coordinate.latitude,
              lng: lot.data?.coordinate.longitude,
            }}
            motionTracking={false}
            icon={
              lot.id === props.selectedLot.id
                ? null
                : lot.status === "À VENDA" &&
                    lot.preReservationCode &&
                    lot.preReservationEnabled &&
                    lot.isOwner
                  ? "https://www.guerini.com.br/mapadevendas/images/ICON_BLUE.png"
                  : lot.status === "À VENDA" &&
                      lot.preReservationCode &&
                      lot.preReservationEnabled
                    ? "https://www.guerini.com.br/mapadevendas/images/RESERVADO.png"
                    : lot.status === "RESERVADO" &&
                        lot.isOwner &&
                        lot.preReservationStatus === "waiting_for_audit"
                      ? "https://www.guerini.com.br/mapadevendas/images/ICON_CHECKLIST.png"
                      : lot.status === "RESERVADO" &&
                          lot.isOwner &&
                          lot.preReservationStatus === "approved"
                        ? "https://www.guerini.com.br/mapadevendas/images/ICON_CONFIRM_W.png"
                        : lot.status === "RESERVADO" &&
                            lot.isOwner &&
                            lot.preReservationStatus === "reproved"
                          ? "https://www.guerini.com.br/mapadevendas/images/ICON_X.png"
                          : lot.status === "À VENDA"
                            ? "https://www.guerini.com.br/mapadevendas/images/AVENDA_PASTEL.png"
                            : lot.status === "VENDIDO"
                              ? "https://www.guerini.com.br/mapadevendas/images/VENDIDO_PASTEL.png"
                              : lot.status === "RESERVADO"
                                ? "https://www.guerini.com.br/mapadevendas/images/RESERVADO_PASTEL.png"
                                : "https://www.guerini.com.br/mapadevendas/images/SEMSTATUS_PASTEL.png"
            }
            onClick={() => props.onLotClick(lot)}
          />
        ))}
    </GoogleMap>
  )),
);

const LotCard = ScrollElement(
  ({
    mode,
    name,
    id,
    item,
    project,
    selectedLot,
    isLinkedLot,
    setSelectedLot,
    onReservationClick,
    onCloseClick,
  }) => (
    <div
      name={name}
      id={id}
      className="card mb-2"
      style={
        selectedLot?.id === item.id
          ? {
              boxShadow: "0px 12px 4px -4px rgba(32,32,32,0.5)",
              zIndex: 2,
              borderWidth: 1,
              borderStyle: isLinkedLot ? "dashed" : "solid ",
              borderColor: "rgba(32,32,32,0.5)",
            }
          : {
              cursor: "pointer",
            }
      }
      onClick={() => {
        if (selectedLot?.id !== item.id) {
          setSelectedLot(item);
        }
      }}
    >
      <div
        className="d-flex justify-content-between m-3"
        style={{ borderBottom: "1px solid #DDD" }}
      >
        <div>
          <div
            className="primary-color"
            style={{ fontSize: "18px", fontWeight: 800 }}
          >
            {item.identifier}
          </div>
          <small className="d-block text-muted">
            {item.kind
              ? item.kind
              : project?.kind === "residential"
                ? "Residencial"
                : project?.kind === "business"
                  ? "Empresarial"
                  : project?.kind === "area"
                    ? "Área"
                    : project?.kind === "mixed"
                      ? "Misto"
                      : ""}
            {project?.name ? ` - ${project?.name}` : ""}
          </small>
        </div>
        <div>
          {mode === "mobile" && (
            <Button
              link
              className="m-0 p-0 pt-1"
              onClick={() => onCloseClick(item)}
            >
              <Icon name="x-circle" />
            </Button>
          )}
        </div>
      </div>
      <div className="px-3 pb-3" style={{ fontSize: "14px" }}>
        <div className="d-flex justify-content-between py-1">
          <span>Área Real (m²)</span>
          <NumberFormat
            value={item.area / 100}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            displayType="text"
            fixedDecimalScale={true}
            renderText={(value) => (
              <span style={{ textAlign: "right" }}>{value}</span>
            )}
          />
        </div>

        {item.originalAreaPrice &&
          parseInt(item.originalAreaPrice) !== parseInt(item.areaPrice) && (
            <div className="d-flex justify-content-between py-1">
              <span>Preço Original do Lote (R$/m²)</span>
              <NumberFormat
                value={item.originalAreaPrice / 100}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                displayType="text"
                fixedDecimalScale={true}
                renderText={(value) => (
                  <span
                    style={{
                      textAlign: "right",
                      textDecorationLine: "line-through",
                    }}
                  >
                    {value}
                  </span>
                )}
              />
            </div>
          )}

        {item.areaPrice && (
          <div className="d-flex justify-content-between py-1">
            <span>Preço Final do Lote (R$/m²)</span>
            <NumberFormat
              value={item.areaPrice / 100}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              displayType="text"
              fixedDecimalScale={true}
              renderText={(value) => (
                <span style={{ textAlign: "right" }}>{value}</span>
              )}
            />
          </div>
        )}

        {item.originalFinalPrice &&
          parseInt(item.originalFinalPrice) !== parseInt(item.finalPrice) && (
            <div className="d-flex justify-content-between py-1">
              <span>Valor Original do Lote</span>
              <NumberFormat
                value={item.originalFinalPrice / 100}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                displayType="text"
                fixedDecimalScale={true}
                renderText={(value) => (
                  <span
                    style={{
                      textAlign: "right",
                      textDecorationLine: "line-through",
                    }}
                  >
                    {value}
                  </span>
                )}
              />
            </div>
          )}

        {item.finalPrice && (
          <div className="d-flex justify-content-between py-1">
            <span>Valor Final do Lote</span>
            <NumberFormat
              value={item.finalPrice / 100}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              displayType="text"
              fixedDecimalScale={true}
              prefix="R$ "
              renderText={(value) => (
                <span style={{ textAlign: "right", fontWeight: 700 }}>
                  {value}
                </span>
              )}
            />
          </div>
        )}

        {item.data?.measurementLink != null &&
          item.data?.measurementLink.length > 0 && (
            <div className="d-flex justify-content-between py-1">
              <span>Medidas, Foto e Observações</span>
              <span style={{ textAlign: "right" }}>
                <a target="_blank" href={item.data?.measurementLink}>
                  Link
                </a>
              </span>
            </div>
          )}

        {item.status !== "À VENDA" && item.reservationCode && (
          <div className="d-flex justify-content-between py-1">
            <span>Protocolo</span>
            <span style={{ textAlign: "right" }}>
              <a target="_blank" href={item.link}>
                {item.reservationCode}
              </a>
            </span>
          </div>
        )}

        {item.status === "À VENDA" &&
          item.preReservationCode &&
          item.preReservationEnabled && (
            <div className="d-flex justify-content-between py-1">
              <span>Protocolo Pré-reserva</span>
              <span style={{ textAlign: "right" }}>
                <a target="_blank" href="#">
                  {item.preReservationCode}
                </a>
              </span>
            </div>
          )}
      </div>
      {selectedLot?.id === item.id &&
        selectedLot?.simulationEnabled &&
        !isLinkedLot && (
          <div className="mx-3 mb-1" style={{ borderTop: "1px solid #DDD" }}>
            <div className="text-right">
              {item.status === "À VENDA" && (
                <Button
                  link
                  className="px-0"
                  onClick={() => onReservationClick(item)}
                >
                  Quero RESERVAR este lote
                </Button>
              )}
            </div>
          </div>
        )}
      {selectedLot.id === item.id && isLinkedLot && (
        <div
          className="d-flex mx-3 mb-1"
          style={{ borderTop: "1px solid #DDD" }}
        >
          <div className="text-center py-2" style={{ fontWeight: 600 }}>
            Este lote pertence a outro projeto, procure o corretor para saber
            mais sobre.
          </div>
        </div>
      )}
    </div>
  ),
);

const Simulator = (props) => {
  const { project, lot, onSimulationFinish } = props;
  const { availableInstallments, installments } = lot.appData;

  const [selectedNumberOfInstallments, setSelectedNumberOfInstallments] =
    React.useState(1);
  const [currentInstallment, setCurrentInstallment] = React.useState(
    installments[availableInstallments[0]],
  );

  const [fundingEntryPercentage, setFundingEntryPercentage] = React.useState(
    (currentInstallment.minimuEntryPercentage * 100).toFixed(0),
  );
  const [fundingEntry, setFundingEntry] = React.useState(
    ((lot.finalPrice * parseInt(fundingEntryPercentage)) / 100).toFixed(0),
  );
  const [fundingEntryRecalculate, setFundingEntryRecalculate] =
    React.useState("");
  const [
    fundingEntryPercentageRecalculate,
    setFundingEntryPercentageRecalculate,
  ] = React.useState("");
  const [fundingInstallmentValue, setFundingInstallmentValue] =
    React.useState(null);
  const debouncedFundingEntry = UseDebounce(fundingEntryRecalculate, 500);
  const debouncedFundingEntryPercentage = UseDebounce(
    fundingEntryPercentageRecalculate,
    500,
  );
  const [outstandingBalance, setOutstandingBalance] = React.useState(
    lot.finalPrice - parseInt(fundingEntry),
  );

  const [fundingIntermediaryDatePicker, setFundingIntermediaryDatePicker] =
    React.useState(false);
  const [fundingIntermediaryDate, setFundingIntermediaryDate] =
    React.useState("");
  const [fundingIntermediaryValue, setFundingIntermediaryValue] =
    React.useState("");
  const [fundingIntermediaries, setFundingIntermediaries] = React.useState([]);

  const [simulateButtonEnabled, setSimulateButtonEnabled] =
    React.useState(false);
  const [simulationStatus, setSimulationStatus] = React.useState(null);
  const [simulation, setSimulation] = React.useState(null);

  React.useEffect(() => {
    const dividend = parseFloat(fundingEntryRecalculate);
    if (!isNaN(dividend)) {
      const percentage = Math.floor((dividend / lot.finalPrice) * 100);
      setFundingEntryPercentage(`${percentage}`);
      setOutstandingBalance(lot.finalPrice - dividend);
    }
  }, [debouncedFundingEntry]);

  React.useEffect(() => {
    const percentage = parseInt(
      fundingEntryPercentageRecalculate.replace(/^0|\D/g, ""),
    );
    if (!isNaN(percentage)) {
      const value = ((lot.finalPrice * percentage) / 100).toFixed(0);
      setFundingEntry(value);
      setOutstandingBalance(lot.finalPrice - parseInt(value));
    }
  }, [debouncedFundingEntryPercentage]);

  React.useEffect(() => {
    setSimulationStatus(null);

    const nearAvailableInstallment =
      availableInstallments.find((p) => selectedNumberOfInstallments <= p) ||
      availableInstallments[availableInstallments.length - 1];
    setCurrentInstallment(installments[nearAvailableInstallment]);

    if (fundingEntryPercentage) {
      const fundingEntryPercentageFloat =
        parseFloat(fundingEntryPercentage.replace("%", "").replace(",", ".")) /
        100;
      if (
        fundingEntryPercentageFloat >= currentInstallment.minimuEntryPercentage
      ) {
        setSimulationStatus("OK");
      } else if (
        fundingEntryPercentageFloat <
          currentInstallment.minimuEntryPercentage &&
        !project.intermediarySimulationEnabled
      ) {
        setSimulationStatus("WARNING_MINIMUM_FUNDING_ENTRY");
      } else {
        setSimulationStatus("WARNING_FUNDING_ENTRY");
      }

      setSimulateButtonEnabled(
        currentInstallment &&
          (project.intermediarySimulationEnabled ||
            (fundingEntryPercentageFloat >=
              currentInstallment.minimuEntryPercentage &&
              !project.intermediarySimulationEnabled)),
      );
    } else {
      setSimulateButtonEnabled(false);
    }

    calculateFundingInstallmentValue();
  }, [outstandingBalance, currentInstallment, selectedNumberOfInstallments]);

  // React.useEffect(() => {
  //   const nearAvailableInstallment = availableInstallments.find(p => selectedNumberOfInstallments <= p) || availableInstallments[availableInstallments.length - 1];
  //   setCurrentInstallment(installments[nearAvailableInstallment]);
  // }, [selectedNumberOfInstallments]);

  React.useEffect(() => {
    if (fundingInstallmentValue) calculateFundingInstallmentValue();
  }, [fundingIntermediaries]);

  const calculateFundingInstallmentValue = () => {
    const balance = fundingIntermediaries.reduce((balance, intermediary) => {
      const monthDiff = Math.ceil(
        moment(intermediary.date, "DD/MM/YYYY").diff(moment(), "months", true),
      );
      return (
        balance +
        PV(currentInstallment.rate, monthDiff, 0, intermediary.value / 100)
      );
    }, outstandingBalance / 100);

    setFundingInstallmentValue(
      parseInt(
        -PMT(currentInstallment.rate, selectedNumberOfInstallments, balance) *
          100,
      ),
    );
  };

  const onContinueClick = () => {
    onSimulationFinish({
      projectId: project?.id,
      identifier: lot.identifier,
      area: lot.area,
      areaPrice: lot.areaPrice,
      finalPrice: lot.finalPrice,
      kind: lot.kind,
      fundingEntry: parseInt(fundingEntry),
      fundingEntryPercent: parseInt(fundingEntryPercentage),
      outstandingBalance: parseInt(outstandingBalance),
      numberOfInstallments: selectedNumberOfInstallments,
      rate: currentInstallment.rate,
      indexingRate: currentInstallment.indexingRate,
      fundingInstallmentValue: fundingInstallmentValue,
      fundingIntermediariesData: [],
    });
  };

  const renderSimulationNotice = () => (
    <>
      {/* {
      fundingIntermediaries.length > 0 ?
        <Block style={[styles.simulationNotice, {backgroundColor: AppTheme.COLORS.LIGHT_RED}]}>
          <div className="d-flex justify-content-between py-1" row space="between">
            <Icon
              family="Font-Awesome"
              size={22}
              name="exclamation-circle"
              color={AppTheme.COLORS.RED}
              style={{marginLeft:4,marginTop:2}}
            />
            <Text size={12} color={AppTheme.COLORS.LABEL} style={{paddingLeft: 12, paddingRight: 24}}>Essas condições estão sujeitas a análise, caso queira continuar mesmo assim abra um chamado.</Text>
          </div>
        </Block>
      : simulationStatus === 'OK' && fundingInstallmentValue  ?
        <Block style={[styles.simulationNotice, {backgroundColor: AppTheme.COLORS.LIGHT_GREEN}]}>
          <div className="d-flex justify-content-between py-1" row space="between">
            <Icon
              family="Font-Awesome"
              size={22}
              name="check-circle"
              color={AppTheme.COLORS.GREEN}
              style={{marginLeft:4,marginTop:2}}
            />
            <Text size={12} color={AppTheme.COLORS.LABEL} style={{paddingLeft: 4, paddingRight: 16}}>
              PARABÉNS, sua solicitação está aprovada, para continuar abra um chamado.
            </Text>
          </div>
        </Block>
      : simulationStatus === 'WARNING_FUNDING_ENTRY' ?
        <Block style={[styles.simulationNotice, {backgroundColor: AppTheme.COLORS.LIGHT_YELLOW}]}>
          <div className="d-flex justify-content-between py-1" row space="between">
            <Icon
              family="Font-Awesome"
              size={22}
              name="exclamation-circle"
              color={AppTheme.COLORS.LABEL}
              style={{marginLeft:4,marginTop:4}}
            />
            <Block style={{paddingLeft: 8, paddingRight: 24}}>
              {
                fundingInstallmentValue ?
                <Text size={12} color={AppTheme.COLORS.LABEL} style={{paddingLeft: 12, paddingRight: 24}}>Essas condições estão sujeitas a análise, caso queira continuar mesmo assim abra um chamado.</Text>
                :
                <>
                  <Text size={12} color={AppTheme.COLORS.LABEL}>Essas condições não são as indicadas, confira nossa recomendação:</Text>
                  <Text size={12} color={AppTheme.COLORS.LABEL} bold>{selectedNumberOfInstallments} vezes = Entrada mínima de {currentInstallment.minimuEntryPercentage * 100}%</Text>
                </>
              }
            </Block>
          </div>
        </Block>
      : simulationStatus === 'WARNING_MINIMUM_FUNDING_ENTRY' ?
        <Block style={[styles.simulationNotice, {backgroundColor: AppTheme.COLORS.LIGHT_YELLOW}]}>
          <div className="d-flex justify-content-between py-1" row space="between">
            <Icon
              family="Font-Awesome"
              size={22}
              name="exclamation-circle"
              color={AppTheme.COLORS.YELLOW}
              style={{marginLeft:4,marginTop:4}}
            />
            <Block style={{paddingLeft: 8, paddingRight: 24}}>
              <Text size={12} color={AppTheme.COLORS.LABEL} bold>O percentual da entrada precisa ser igual ou superior a {currentInstallment.minimuEntryPercentage * 100}%</Text>
            </Block>
          </div>
        </Block>
      : null
    } */}
    </>
  );

  return (
    <div>
      <Form.Group
        label={`Percentual da Entrada (Mínimo - ${currentInstallment.minimuEntryPercentage * 100}%)`}
      >
        <Form.InputGroup>
          <Form.Input
            type="number"
            pattern="\d*"
            maxWidth={2}
            value={fundingEntryPercentage}
            onChange={(e) => {
              let rawText = e.target.value.replace(/^0|\D/g, "");
              while (parseInt(rawText) > 100) rawText = rawText.substring(1);

              setFundingEntryPercentage(`${rawText}`);
              setFundingEntryPercentageRecalculate(`${rawText}`);
            }}
            name="fundingEntryPercentage"
          />
          <Form.InputGroupAppend>
            <Form.InputGroupText>%</Form.InputGroupText>
          </Form.InputGroupAppend>
        </Form.InputGroup>
      </Form.Group>

      <Form.Group label="Valor da Entrada">
        <Form.InputGroup>
          <Form.InputGroupPrepend>
            <Form.InputGroupText>R$</Form.InputGroupText>
          </Form.InputGroupPrepend>
          <Form.Input
            value={formatValue({
              value: (fundingEntry / 100).toFixed(2),
              groupSeparator: ".",
              decimalSeparator: ",",
            })}
            onChange={(e) => {
              const value = parseInt(e.target.value.replace(/^0|\D/g, ""));
              setFundingEntry(value);
              setFundingEntryRecalculate(value);
            }}
            id="fundingEntry"
            name="fundingEntry"
          />
        </Form.InputGroup>
      </Form.Group>

      <Form.Group label="Saldo Devedor">
        <Form.InputGroup>
          <Form.InputGroupPrepend>
            <Form.InputGroupText>R$</Form.InputGroupText>
          </Form.InputGroupPrepend>
          <CurrencyInput
            id="outstandingBalance"
            name="outstandingBalance"
            decimalsLimit={2}
            value={(outstandingBalance / 100.0).toFixed(2)}
            fixedDecimalLength={2}
            decimalSeparator=","
            groupSeparator="."
            disabled={true}
            className="form-control"
          />
        </Form.InputGroup>
      </Form.Group>
      <Form.Group
        label={`Quantidade de Parcelas ${currentInstallment?.indexingRate ? `(Juros ${currentInstallment?.indexingRate})` : ""}`}
      >
        <Form.Select
          name="numberOfInstalments"
          defaultValue={selectedNumberOfInstallments + ""}
          onChange={(e) => {
            setSelectedNumberOfInstallments(parseInt(e.target.value));
          }}
        >
          {new Array(availableInstallments[availableInstallments.length - 1])
            .fill(null)
            .map((value, index) => (
              <option value={index + 1}>{index + 1}</option>
            ))}
        </Form.Select>
      </Form.Group>

      <Form.Group label="Parcelas">
        <Form.InputGroup>
          <Form.InputGroupPrepend>
            <Form.InputGroupText>R$</Form.InputGroupText>
          </Form.InputGroupPrepend>
          <CurrencyInput
            id="fundingInstallmentValue"
            name="fundingInstallmentValue"
            decimalsLimit={2}
            value={(fundingInstallmentValue / 100.0).toFixed(2)}
            fixedDecimalLength={2}
            decimalSeparator=","
            groupSeparator="."
            disabled={true}
            className="form-control"
          />
        </Form.InputGroup>
      </Form.Group>

      <div>
        <Button
          block
          outline
          color="primary"
          disabled={!simulateButtonEnabled}
          onClick={onContinueClick}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
};

const mediumOptions = [
  { label: "Jornal", value: "Jornal" },
  { label: "Revista", value: "Revista" },
  { label: "Email Marketing", value: "Email Marketing" },
  { label: "Google", value: "Google" },
  { label: "Facebook", value: "Facebook" },
  { label: "Instagram", value: "Instagram" },
  { label: "Outdoor", value: "Outdoor" },
  { label: "Folder", value: "Folder" },
  { label: "Indicação", value: "Indicação" },
  { label: "Já é cliente", value: "Já é cliente" },
  { label: "Site da Guerini", value: "Site da Guerini" },
  { label: "Televisão", value: "Televisão" },
  { label: "Rádio", value: "Rádio" },
  { label: "Visita ao Empreendimento", value: "Visita ao Empreendimento" },
  { label: "Oferta Corretor", value: "Oferta Corretor" },
];

function ProtocolSelfMapProjectPage() {
  const history = useHistory();

  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [id, setId] = React.useState(null);
  const [brokerHash, setBrokerHash] = React.useState(null);
  const [mapZoom, setMapZoom] = React.useState(17);
  const [data, setData] = React.useState(null);
  const [selectedLot, setSelectedLot] = React.useState({});
  const [mode, setMode] = React.useState("desktop");

  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [document, setDocument] = React.useState("");
  const [cellphone, setCellphone] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [hasProtocol, setHasProtocol] = React.useState(false);
  const [protocol, setProtocol] = React.useState("");
  const [medium, setMedium] = React.useState("");
  const [errors, setErrors] = React.useState({});
  const [valid, setValid] = React.useState(false);
  const [simulationOptions, setSimulationOptions] = React.useState([]);
  const [simulatorProps, setSimulatorProps] = React.useState({});
  const [proposal, setProposal] = React.useState({});
  const [modalStep, setModalStep] = React.useState(0);
  const [firstInstallmentAt, setFirstInstallmentAt] = React.useState(
    proposal?.numberOfInstallments > 1 ? "" : null,
  );
  const [firstInstallmentDates, setFirstInstallmentDates] = React.useState([]);

  const mapRef = React.useRef(null);

  React.useEffect(() => {
    if (history.location.search && history.location.search.length > 0) {
      const params = qs.parse(history.location.search.replace("?", ""));
      if (params.id && params.id.length > 0) {
        setId(params.id);
      }

      if (params.h && params.h.length > 0) {
        setBrokerHash(params.h);
      }

      if (params.mapZoom && !isNaN(parseInt(params.mapZoom))) {
        setMapZoom(parseInt(params.mapZoom));
      }

      if (params.mode && params.mode.length > 0) {
        setMode(params.mode);
      } else if (isMobile) {
        setMode("mobile");
      }

      const firstInstallmentMonth = moment().date() < 25 ? 1 : 2;

      setFirstInstallmentDates([
        {
          value: moment()
            .add(firstInstallmentMonth, "months")
            .date(5)
            .toISOString(),
          label: moment()
            .add(firstInstallmentMonth, "months")
            .date(5)
            .format("DD/MM/YYYY"),
        },
        {
          value: moment()
            .add(firstInstallmentMonth, "months")
            .date(15)
            .toISOString(),
          label: moment()
            .add(firstInstallmentMonth, "months")
            .date(15)
            .format("DD/MM/YYYY"),
        },
        {
          value: moment()
            .add(firstInstallmentMonth, "months")
            .date(25)
            .toISOString(),
          label: moment()
            .add(firstInstallmentMonth, "months")
            .date(25)
            .format("DD/MM/YYYY"),
        },
      ]);
    }
  }, []);

  React.useEffect(() => {
    (async () => {
      if (id && brokerHash) {
        const res = await fetch(`/api/portal/maps/${id}/self/${brokerHash}`);

        const json = await res.json();
        json.linkedProjects = json?.linkedProjects?.reduce(
          (acc, project) => ({ ...acc, [project.id]: project }),
          {},
        );

        setData(json);
      }
    })();
  }, [id, brokerHash]);

  React.useEffect(() => {
    if (selectedLot?.id && data && mapRef.current) {
      scroller.scrollTo(`${selectedLot.id}`, {
        containerId: "lots",
        smooth: true,
      });

      mapRef.current.panTo(
        new google.maps.LatLng(
          selectedLot?.data?.coordinate.latitude,
          selectedLot?.data?.coordinate.longitude,
        ),
      );
    }
  }, [selectedLot]);

  React.useEffect(() => {
    const newErrors = {};

    if (hasProtocol) {
      if (!protocol) newErrors.protocol = "Campo obrigatório";
    } else {
      if (!name) newErrors.name = "Campo obrigatório";
      else if (name.match(/\w+ \w+/i) === null)
        newErrors.name = "Nome e sobrenome são obrigatórios";

      if (!email) newErrors.email = "Campo obrigatório";
      else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/))
        newErrors.email = "Email inválido";

      if (!cellphone) newErrors.cellphone = "Campo obrigatório";

      if (!!document && !cpf.isValid(document))
        newErrors.document = "CPF inválido";
    }

    setErrors(newErrors);
    setValid(Object.keys(newErrors).length === 0);
  }, [name, email, cellphone, hasProtocol, protocol]);

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!valid) {
      return alert(
        "O formulário está com erros, corrija os antes de continuar",
      );
    }

    try {
      if (window.confirm("Você tem certeza que continuar?")) {
        const res = await fetch(`/api/portal/maps/${id}/self/${brokerHash}`, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            clientName: name,
            clientEmail: email,
            medium,
            clientMobilePhone: cellphone,
            clientDocument: document,
            observation: message,
            hasProtocol: hasProtocol,
            number: protocol,
            ...proposal,
            firstInstallmentAt,
            formattedRate: `${(proposal.rate * 100).toFixed(4).replace(".", ",")}%`,
            formattedArea: formatValue({
              value: (proposal.area / 100.0).toFixed(2),
              groupSeparator: ".",
              decimalSeparator: ",",
            }),
            formattedFinalPrice: formatValue({
              prefix: "R$ ",
              value: (proposal.finalPrice / 100.0).toFixed(2),
              groupSeparator: ".",
              decimalSeparator: ",",
            }),
            formattedFundingEntry: formatValue({
              prefix: "R$ ",
              value: (proposal.fundingEntry / 100.0).toFixed(2),
              groupSeparator: ".",
              decimalSeparator: ",",
            }),
            formattedFundingEntryPercent: `${proposal.fundingEntryPercent}%`,
            formattedOutstadingBalance: formatValue({
              prefix: "R$ ",
              value: (proposal.outstandingBalance / 100.0).toFixed(2),
              groupSeparator: ".",
              decimalSeparator: ",",
            }),
            formattedFundingInstallmentValue: formatValue({
              prefix: "R$ ",
              value: (proposal.fundingInstallmentValue / 100.0).toFixed(2),
              groupSeparator: ".",
              decimalSeparator: ",",
            }),
          }),
        });

        alert("Sua solicitação foi enviada com sucesso");

        setModalIsOpen(false);

        window.location.reload();
      }
    } catch (err) {
      console.log(err);
      alert("Algo deu errado, tente novamente mais tarde");
    }
  };

  const onReservationClick = (item) => {
    setSimulationOptions([
      {
        text: (
          <NumberFormat
            value={item.finalPrice / 100}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            displayType="text"
            fixedDecimalScale={true}
            renderText={(value) => (
              <span
                style={{ fontWeight: 700 }}
              >{`R$ ${value} À vista${item.appdata?.inCashDiscount ? ` - Desconto de ${(item.appdata?.inCashDiscount * 100).toFixed(2).replace(".", ",")}%` : ""}`}</span>
            )}
          />
        ),
        onPress: () => {
          setProposal({
            projectId: data?.project?.id,
            identifier: item.identifier,
            area: item.area,
            areaPrice: item.areaPrice,
            finalPrice: parseInt(item.finalPrice),
            kind: item.kind,
            fundingEntry: 0,
            fundingEntryPercent: 0,
            outstandingBalance: 0,
            numberOfInstallments: 1,
            rate: 0,
            indexingRate: 0,
            fundingInstallmentValue:
              item.finalPrice -
              (item.appData.inCashDiscount
                ? item.appData.inCashDiscount * item.finalPrice
                : 0),
            fundingIntermediariesData: [],
            text: (
              <NumberFormat
                value={item.finalPrice / 100}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                displayType="text"
                fixedDecimalScale={true}
                renderText={(value) => (
                  <span
                    style={{ textAlign: "right", fontWeight: 700 }}
                  >{`R$ ${value} À vista${item.appdata?.inCashDiscount ? ` - Desconto de ${(item.appdata?.inCashDiscount * 100).toFixed(2).replace(".", ",")}%` : ""}`}</span>
                )}
              />
            ),
          });
          setFirstInstallmentAt(null);

          setModalStep(2);
          // window.open(`https://form.jotform.com/201803381399660?produto=${data?.project.name}&quadralote=${item.identifier}&area=${(parseInt(item.area)/100).toFixed(2).replace('.', ',')}+m%C2%B2&formadepagamento=${`R$ ${(parseInt(item.finalPrice) / 100).toFixed(2).replace('.', ',')} À vista${item.appdata?.inCashDiscount ? ` - Desconto de ${(item.appdata?.inCashDiscount * 100).toFixed(2).replace('.', ',')}%` : ''}`}&precodoterreno=R$%20${(parseInt(item.finalPrice)/100).toFixed(2).replace('.', ',')}&origem=Mapa%20Público`, '_blank')
        },
      },
      ...item.appData?.availableInstallments?.map((i) => {
        const fundingEntry =
          item.finalPrice * item.appData.installments[i].minimuEntryPercentage;
        const outstandingBalance =
          item.finalPrice -
          item.finalPrice * item.appData?.installments[i].minimuEntryPercentage;
        const fundingInstallmentValue = parseInt(
          -PMT(item.appData?.installments[i].rate, i, outstandingBalance),
        );

        return {
          text: (
            <NumberFormat
              value={fundingInstallmentValue / 100}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              displayType="text"
              fixedDecimalScale={true}
              renderText={(value) => (
                <span
                  style={{ fontWeight: 700 }}
                >{`Entrada de ${item.appData?.installments[i].minimuEntryPercentage * 100}% + ${i}x R$ ${value}${item.appData?.installments[i].indexingRate ? ` + Idx` : ""}`}</span>
              )}
            />
          ),
          onPress: () => {
            setProposal({
              projectId: data?.project?.id,
              identifier: item.identifier,
              area: item.area,
              areaPrice: item.areaPrice,
              finalPrice: parseInt(item.finalPrice),
              kind: item.kind,
              fundingEntry: parseInt(fundingEntry.toFixed(0)),
              fundingEntryPercent:
                item.appData.installments[i].minimuEntryPercentage * 100,
              outstandingBalance: parseInt(outstandingBalance.toFixed(0)),
              numberOfInstallments: i,
              rate: item.appData.installments[i].rate,
              indexingRate: item.appData.installments[i].indexingRate,
              fundingInstallmentValue: parseInt(
                fundingInstallmentValue.toFixed(0),
              ),
              fundingIntermediariesData: [],
              text: (
                <NumberFormat
                  value={fundingInstallmentValue / 100}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  displayType="text"
                  fixedDecimalScale={true}
                  renderText={(value) => (
                    <span
                      style={{ textAlign: "right", fontWeight: 700 }}
                    >{`Entrada de ${item.appData?.installments[i].minimuEntryPercentage * 100}% + ${i}x R$ ${value}${item.appData?.installments[i].indexingRate ? ` + Idx` : ""}`}</span>
                  )}
                />
              ),
            });
            setFirstInstallmentAt(firstInstallmentDates?.[0]?.value);

            setModalStep(2);
          },
        };
      }),
      {
        text: (
          <span style={{ fontWeight: 700 }}>
            Gostaria de propor outra forma de pagamento
          </span>
        ),
        onPress: () => {
          setProposal({});

          setSimulatorProps({
            lot: item,
            project: data?.project,
            onSimulationFinish: (data) => {
              setProposal(data);

              setModalStep(2);
            },
          });

          setModalStep(1);
        },
      },
    ]);

    setProposal({});
    setModalStep(0);
    setModalIsOpen(true);
  };

  return data ? (
    <div style={{ height: "100%", width: "100%" }}>
      <div
        style={{
          bottom: 0,
          right: 0,
          position: "absolute",
          top: 0,
          left: mode === "desktop" ? 384 : 0,
        }}
      >
        <Map
          mapRef={mapRef}
          data={data}
          selectedLot={selectedLot}
          onLotClick={setSelectedLot}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyB4kgwYSTYdTsT6efHQLYOPZUuB-S5zTNI&v=3.42&libraries=geometry,drawing,places"
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `100%` }} />}
          mapElement={<div style={{ height: `100%` }} />}
          mapZoom={mapZoom}
        />
      </div>
      {mode === "desktop" ? (
        <div
          style={{
            backgroundColor: "#EEF0F2",
            bottom: 0,
            left: 0,
            position: "absolute",
            top: 0,
            width: 384,
            zIndex: 10,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              left: 0,
              position: "absolute",
              right: 0,
              top: 0,
              boxShadow: "0px 8px 4px -4px rgba(32,32,32,0.2)",
              borderBottom: "1px solid rgba(32,32,32,0.2)",
              zIndex: 10,
              overflowY: "none",
            }}
          >
            <div
              className="d-flex justify-content-between p-3 pb-1"
              style={{ borderBottom: "1px solid #DDD" }}
            >
              <div
                className="primary-color"
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  lineHeight: "36px",
                }}
              >
                {data?.project?.name}
              </div>
              <div>
                <Button
                  link
                  className="px-0"
                  onClick={async () => {
                    window.location.reload();
                  }}
                >
                  Recarregar
                </Button>
              </div>
            </div>
            <div className="p-3 pt-1" style={{ fontSize: "14px" }}>
              <div className="d-flex justify-content-between py-1">
                <span>Corretor(a)</span>
                <span>{data?.broker.name}</span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Celular</span>
                <span>{data?.broker.mobilePhone}</span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Email</span>
                <span>{data?.broker.email}</span>
              </div>
            </div>
          </div>
          <div
            id="lots"
            style={{
              backgroundColor: "#EEF0F2",
              bottom: 0,
              left: 0,
              overflowY: "scroll",
              paddingTop: 8,
              position: "absolute",
              right: 0,
              top: 172,
            }}
          >
            {data?.lots?.map((lot) => (
              <LotCard
                mode={mode}
                key={`${data?.project?.id}_${lot.id}`}
                name={`${lot.id}`}
                item={lot}
                isLinkedLot={false}
                project={data?.project}
                selectedLot={selectedLot}
                setSelectedLot={setSelectedLot}
                onReservationClick={onReservationClick}
              />
            ))}
            {data?.linkedLots?.map((lot) => (
              <LotCard
                mode={mode}
                key={`${data?.project?.id}_${lot.id}`}
                name={`${lot.id}`}
                item={lot}
                isLinkedLot={true}
                project={data?.linkedProjects?.[lot.projectId]}
                selectedLot={selectedLot}
                setSelectedLot={setSelectedLot}
                onReservationClick={null}
              />
            ))}
          </div>
        </div>
      ) : (
        <>
          <div
            style={{
              left: 0,
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 10,
            }}
          >
            <div
              className="d-flex justify-content-between px-3 py-2"
              style={{
                borderBottom: "1px solid #DDD",
                backgroundColor: "#FFF",
              }}
            >
              <div
                className="primary-color text-center"
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  lineHeight: "24px",
                }}
              >
                {data?.project?.name}
              </div>
            </div>
            <div
              className="px-3 py-1 pb-2"
              style={{
                fontSize: "14px",
                backgroundColor: "#FFF",
                borderBottom: "1px solid #DDD",
              }}
            >
              <div className="d-flex justify-content-between py-1">
                <span>Corretor(a)</span>
                <span>{data?.broker.name}</span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Celular</span>
                <span>{data?.broker.mobilePhone}</span>
              </div>
            </div>
          </div>
          <div
            style={{
              left: 0,
              position: "absolute",
              bottom: -8,
              right: 0,
              zIndex: 10,
            }}
          >
            {selectedLot?.id && (
              <LotCard
                mode={mode}
                item={selectedLot}
                project={
                  data?.linkedProjects?.[selectedLot?.projectId] ||
                  data?.protocol?.project ||
                  {}
                }
                isLinkedLot={
                  data?.linkedProjects?.[selectedLot?.projectId] !== undefined
                }
                selectedLot={selectedLot}
                setSelectedLot={setSelectedLot}
                onReservationClick={onReservationClick}
                onCloseClick={(item) => {
                  setSelectedLot({});
                }}
              />
            )}
          </div>
        </>
      )}

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => {
          setModalIsOpen(false);
        }}
        style={{
          content:
            mode === "desktop"
              ? {
                  top: 0,
                  left: 0,
                  bottom: 0,
                  minWidth: 600,
                  width: 600,
                  zIndex: 100,
                  overflow: "scroll",
                }
              : {
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 100,
                  overflow: "scroll",
                },
          overlay: {
            zIndex: 100,
          },
        }}
        contentLabel="Simular"
      >
        <div
          className="d-flex justify-content-between mt-1 mb-3"
          style={{ borderBottom: "1px solid #DDD" }}
        >
          <div>
            <div
              className="primary-color"
              style={{ fontSize: "18px", fontWeight: 800 }}
            >
              Reserva do Lote {selectedLot?.identifier}
            </div>
            <small className="d-block text-muted">
              {selectedLot?.kind
                ? selectedLot?.kind
                : data?.project?.kind === "residential"
                  ? "Residencial"
                  : data?.project?.kind === "business"
                    ? "Empresarial"
                    : data?.project?.kind === "area"
                      ? "Área"
                      : data?.project?.kind === "mixed"
                        ? "Misto"
                        : ""}
            </small>
          </div>
          <div>
            {
              <Button
                link
                className="m-0 p-0 pt-1"
                onClick={() => setModalIsOpen(false)}
              >
                <Icon name="x-circle" />
              </Button>
            }
          </div>
        </div>
        <div className="pb-3" style={{ fontSize: "14px" }}>
          <div className="d-flex justify-content-between py-1">
            <span>Área Real (m²)</span>
            <NumberFormat
              value={selectedLot?.area / 100}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              displayType="text"
              fixedDecimalScale={true}
              renderText={(value) => (
                <span style={{ textAlign: "right" }}>{value}</span>
              )}
            />
          </div>

          {selectedLot?.areaPrice && (
            <div className="d-flex justify-content-between py-1">
              <span>Preço Final do Lote (R$/m²)</span>
              <NumberFormat
                value={selectedLot?.areaPrice / 100}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                displayType="text"
                fixedDecimalScale={true}
                renderText={(value) => (
                  <span style={{ textAlign: "right" }}>{value}</span>
                )}
              />
            </div>
          )}

          {selectedLot?.finalPrice && (
            <div className="d-flex justify-content-between py-1">
              <span>Valor Final do Lote</span>
              <NumberFormat
                value={selectedLot?.finalPrice / 100}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                displayType="text"
                fixedDecimalScale={true}
                prefix="R$ "
                renderText={(value) => (
                  <span style={{ textAlign: "right", fontWeight: 700 }}>
                    {value}
                  </span>
                )}
              />
            </div>
          )}
          {modalStep === 2 && (
            <>
              <div className="d-flex justify-content-between py-1">
                <NumberFormat
                  value={proposal?.fundingEntryPercent}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  displayType="text"
                  fixedDecimalScale={true}
                  prefix=""
                  suffix="%"
                  renderText={(value) => (
                    <span style={{ textAlign: "right" }}>
                      Entrada ({value})
                    </span>
                  )}
                />
                <NumberFormat
                  value={proposal?.fundingEntry / 100}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  displayType="text"
                  fixedDecimalScale={true}
                  prefix="R$ "
                  renderText={(value) => (
                    <span style={{ textAlign: "right", fontWeight: 700 }}>
                      {value}
                    </span>
                  )}
                />
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Saldo Devedor</span>
                <NumberFormat
                  value={proposal?.outstandingBalance / 100}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  displayType="text"
                  fixedDecimalScale={true}
                  prefix="R$ "
                  renderText={(value) => (
                    <span style={{ textAlign: "right", fontWeight: 700 }}>
                      {value}
                    </span>
                  )}
                />
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Juros</span>
                <NumberFormat
                  value={parseFloat((proposal?.rate * 100).toFixed(4))}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  displayType="text"
                  fixedDecimalScale={true}
                  prefix=""
                  suffix="%"
                  renderText={(value) => (
                    <span style={{ textAlign: "right" }}>{value}</span>
                  )}
                />
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Indexação</span>
                <span style={{ textAlign: "right" }}>
                  {proposal?.indexingRate}
                </span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Número de Parcelas</span>
                <span style={{ textAlign: "right" }}>
                  {proposal?.numberOfInstallments}
                </span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Valor da Parcela</span>
                <NumberFormat
                  value={proposal?.fundingInstallmentValue / 100}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  displayType="text"
                  fixedDecimalScale={true}
                  prefix="R$ "
                  renderText={(value) => (
                    <span style={{ textAlign: "right", fontWeight: 700 }}>
                      {value}
                    </span>
                  )}
                />
              </div>
              <h5 style={{ marginTop: 16 }}>Dados do Corretor:</h5>
              <div className="d-flex justify-content-between py-1">
                <span>Nome</span>
                <span style={{ textAlign: "right" }}>{data?.broker.name}</span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Email</span>
                <span style={{ textAlign: "right" }}>{data?.broker.email}</span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Celular</span>
                <span style={{ textAlign: "right" }}>
                  {data?.broker.mobilePhone}
                </span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>CRECI</span>
                <span style={{ textAlign: "right" }}>{data?.broker.creci}</span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Imobiliária</span>
                <span style={{ textAlign: "right" }}>
                  {data?.broker.realState}
                </span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>CNPJ Imobiliária</span>
                <span style={{ textAlign: "right" }}>
                  {data?.broker.realStateDocument}
                </span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>CRECI</span>
                <span style={{ textAlign: "right" }}>
                  {data?.broker.realStateCreci}
                </span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Responsável Imobiliária</span>
                <span style={{ textAlign: "right" }}>
                  {data?.broker.realStateResponsibleName}
                </span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Celular Responsável</span>
                <span style={{ textAlign: "right" }}>
                  {data?.broker.realStateResponsibleMobilePhone}
                </span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Email Responsável</span>
                <span style={{ textAlign: "right" }}>
                  {data?.broker.realStateResponsibleEmail}
                </span>
              </div>
            </>
          )}
          {modalStep === 1 && (
            <div className="d-flex justify-content-between py-1">
              <span>Proposta</span>
              {proposal.text}
            </div>
          )}
        </div>
        <div>
          {modalStep === 0 && (
            <div>
              <h5>Escolha uma proposta de pagamento:</h5>
              <Button.List>
                {simulationOptions.map((option, i) => (
                  <Button
                    block
                    outline
                    key={`o-${i}`}
                    color="primary"
                    onClick={(e) => option.onPress(e)}
                  >
                    {option.text}
                  </Button>
                ))}
              </Button.List>
            </div>
          )}
          {modalStep === 1 && (
            <div>
              <h5>Faça a sua simulação abaixo:</h5>
              <Simulator {...simulatorProps} />
            </div>
          )}
          {modalStep === 2 && (
            <div style={{ marginTop: 4 }}>
              <h5>Preencha os seus dados:</h5>
              <Form onSubmit={onSubmit}>
                <Form.Group label="Você já tem um protocolo Guerini?">
                  <Form.Select
                    name="hasProtocol"
                    defaultValue={"false"}
                    onChange={(e) => {
                      setHasProtocol(e.target.value === "true");
                    }}
                  >
                    <option value="false">Não</option>
                    <option value="true">Sim</option>
                  </Form.Select>
                </Form.Group>
                {hasProtocol ? (
                  <FormTextInput
                    name="protocol"
                    label="Qual o seu protocolo?"
                    onChange={(e) => {
                      setProtocol(e.target.value);
                    }}
                    value={protocol}
                    error={errors && errors?.protocol}
                  />
                ) : (
                  <>
                    <FormTextInput
                      name="name"
                      label="Qual o seu nome completo, Cliente?"
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      value={name}
                      error={errors && errors?.name}
                    />
                    <FormTextInput
                      name="email"
                      label="Qual o seu email para contato, Cliente?"
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      value={email}
                      error={errors && errors?.email}
                    />
                    <InputMask
                      mask="(99) 99999-9999"
                      value={cellphone}
                      onChange={(e) => {
                        setCellphone(e.target.value);
                      }}
                    >
                      {(inputProps) => (
                        <FormTextInput
                          {...inputProps}
                          name="cellphone"
                          label="Qual o seu celular para contato, Cliente?"
                          error={errors && errors?.cellphone}
                        />
                      )}
                    </InputMask>
                    <FormTextInput
                      name="document"
                      label="Qual o seu CPF/CNPJ, Cliente?"
                      onChange={(e) => {
                        setDocument(e.target.value);
                      }}
                      value={document}
                      error={errors && errors?.document}
                    />

                    <Form.Group label="Como conheceu a Guerini?">
                      <Form.Select
                        name="medium"
                        defaultValue={"Google"}
                        onChange={(e) => {
                          setMedium(e.target.value);
                        }}
                      >
                        {mediumOptions.map((option) => (
                          <option value={option.value}>{option.label}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </>
                )}

                <Form.Group label="Data da 1a. Parcela">
                  <Form.Select
                    name="firstInstallmentAt"
                    defaultValue={firstInstallmentDates[0]?.value}
                    onChange={(e) => {
                      setFirstInstallmentAt(e.target.value);
                    }}
                  >
                    {firstInstallmentDates.map((option) => (
                      <option value={option.value}>{option.label}</option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <FormTextInput
                  name="message"
                  label="Quer deixar alguma mensagem?"
                  onChange={(e) => {
                    setMessage(e.target.value);
                  }}
                  value={message}
                  error={errors && errors?.message}
                />

                <Button
                  type="submit"
                  block
                  outline
                  color="primary"
                  disabled={!data?.project?.reservationEnabled || !valid}
                >
                  {data?.project?.reservationEnabled ? "Enviar" : "Em breve..."}
                </Button>
              </Form>
            </div>
          )}
        </div>
      </Modal>
    </div>
  ) : (
    <div
      className="page"
      style={{
        backgroundImage: "url('./assets/images/landing_background.jpg')",
        backgroundSize: "cover",
      }}
    />
  );
}

export default ProtocolSelfMapProjectPage;
